import * as Sentry from "@sentry/vue";
import { API } from "@/api/api";
import { useAppStore } from "@/store/app.store";
import type { DispatcherProfileDto } from "@/api/dispatchers/dto/dispatcher-profile.dto";

export function useCurrentDispatcher() {
  const api = new API();
  const appStore = useAppStore();

  const loadCurrentDispatcher = async (): Promise<DispatcherProfileDto | null> => {
    let profile: DispatcherProfileDto | null = null;

    try {
      const resp = await api.dispatchers.getCurrentDispatcher();
      profile = resp.data ?? null;
    } catch (err) {
      console.error("Error load current dispatcher", err);
      return null;
    }

    if (!profile) {
      return null;
    }

    appStore.setDispatcher(profile);
    Sentry.setUser({
      email: profile.email,
      id: profile.id ?? undefined,
      companyId: profile.companyId,
      companyName: profile.company?.name,
      roles: profile.roles,
    });

    return profile;
  };

  return { loadCurrentDispatcher };
}
